import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useTranslation } from 'react-i18next';
import { MediaUsageLog } from '../../types/MediaUsage';

interface UserMediaUsageProps {
  usageData: MediaUsageLog[];
}

const UserMediaUsage: React.FC<UserMediaUsageProps> = ({ usageData }) => {
  const { t } = useTranslation();

  const groupedByMedia = usageData.reduce(
    (acc, log) => {
      if (!acc[log.mediaId]) {
        acc[log.mediaId] = {
          title: log.mediaTitle,
          type: log.mediaType,
          isTimeTracked: log.isTimeTracked,
          logs: [],
        };
      }
      acc[log.mediaId].logs.push(log);
      return acc;
    },
    {} as Record<string, { title: string; type: string; isTimeTracked?: boolean | null; logs: MediaUsageLog[] }>
  );

  if (usageData.length === 0) {
    return <Typography>{t('user_media_usage_no_data')}</Typography>;
  }

  return (
    <div>
      {Object.entries(groupedByMedia).map(([mediaId, data]) => (
        <Accordion key={mediaId}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>
              {data.title} (
              {data.type === 'audiobook' && data.isTimeTracked ? `${data.type} (${t('reports.tracked')})` : data.type})
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <TableContainer component={Paper}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>{t('media_usage_chunk_start_time')}</TableCell>
                    <TableCell align="right">{t('media_usage_duration_seconds')}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data.logs.map((log, index) => (
                    <TableRow key={index}>
                      <TableCell>{new Date(log.chunkStartTime).toLocaleString('fi-FI')}</TableCell>
                      <TableCell align="right">{log.duration}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
};

export default UserMediaUsage;
